<span class="pill pill--{{ tone() }}">{{ label() }}</span>
